/* @ngInject */
export default class BuildingDocumentsCtrl {
    constructor(
        $scope,
        $state,
        $window,
        Utility,
        $timeout,
        $interval,
        TelemetryService,
        BuildingsService,
        NavigationService,
        LocalStorageService,
        InternalLinksService,
        buildingDocumentsDataService
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.TelemetryService = TelemetryService;
        this.BuildingsService = BuildingsService;
        this.NavigationService = NavigationService;
        this.LocalStorageService = LocalStorageService;
        this.InternalLinksService = InternalLinksService;
        this.buildingDocumentsDataService = buildingDocumentsDataService;

        this.init();
    }

    init() {
        this.isBusy = false;
        this.loading = true;
        this.content = undefined;
        this.buildingDocuments = [];
        this.buildingDocumentsData = [];
        this.buildingDocumentsFlatFile = [];
        this.buildingDocumentsBreadCrumbs = [
            {
                Title: 'Home',
                Level: null,
                TreeId: null,
                ParentId: null
            }
        ];
        this.buildingsDataService = this.BuildingsService;
        this.buildingDocumentsData = this.buildingDocumentsDataService;

        this.activate();
        var vm = this;
        this._handleEvents();
    }

    activate() {
        const promise = this.$interval(() => {
            const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
            if (selectedBuildingRef) {
                this.onSelectedBuildingChanged({}, selectedBuildingRef);
                this.$interval.cancel(promise);
            }
        }, 350);
    }

    _handleEvents() {
        var ref = this;

        this.$scope.$on('selected-building-changed', this.onSelectedBuildingChanged.bind(ref));

        this.$scope.$watch(
            'documentsVm.buildingDocumentsData.documentsData.BuildingDocuments',
            (newValue) => {
                this.buildingDocumentsFlatFile = [];
                this.buildingDocuments = [];
                var temp = this.$state.params;
                if (!!newValue) {
                    newValue.forEach((document) => {
                        if (temp.isItFinancialsSection == true) {
                            this.buildingDocumentsFlatFile.push(document);
                            this.buildingDocuments.push(document);
                        }
                        else {
                            if (document.Title != "Monthly Financial Statements") {
                                this.buildingDocumentsFlatFile.push(document);
                                this.buildingDocuments.push(document);
                            }
                        }
                    });
                }
            },
            true
        );
    }

    onSelectedBuildingChanged(event, schemeRef) {
        let wasSuccessful = false;
        schemeRef = schemeRef ? schemeRef : this.BuildingsService.getSelectedBuildingRef();
        if (schemeRef && schemeRef.length > 2) {
            this._switchLoadingIndicator(true);
            this.buildingDocumentsDataService
                .getBuildingDocuments(schemeRef)
                .then(
                    () => {
                        this.buildingDocumentsBreadCrumbs = [
                            {
                                Title: 'Home',
                                Level: null,
                                Id: null,
                                FatherId: null
                            }
                        ];

                        wasSuccessful = true;
                    },
                    (err) => {
                        console.error('Error while getting building documents data: ', err);
                    }
                )
                .finally(async () => {
                    await this._switchLoadingIndicator(false);
                    if (wasSuccessful) {
                        this.navigate();
                    }
                });
        }
    }

    navigate() {
        let nav = this.Utility.QueryString('nav');
        if (!!nav) {
            nav = decodeURI(nav);
            const $overlay = angular.element('#overlay');
            this.$timeout(() => $overlay.show());

            const paths = nav.split('>');
            paths.map((path) => {
                const clickFolder = angular.element('.document-layout-title p').toArray().find((folder) => {
                    const $folder = angular.element(folder);
                    return $folder.text().trim().toLowerCase() === path.toLowerCase();
                });

                if (!!clickFolder) {
                    angular.element(clickFolder).trigger('click');
                }
            });

            this.$timeout(() => $overlay.hide(), 1000);
        }
    }

    openFiles() {
        angular.element('.open-docs').trigger('click');
    }

    async buildingDocumentsFolderClick(id) {
        this.NavigationService.gotoTop();

        let document;
        for (let i = 0; i < this.buildingDocumentsFlatFile.length; i++) {
            document = this.buildingDocumentsFlatFile[i];
            if (document.TreeId === id) {
                break;
            }
        }

        if (document.RecordClassification == 3) {
            const baseURL = this.InternalLinksService.getLink('DocumentsApiById');
            const url = baseURL.replace('{documentId}', document.DatabaseId);

            const documentTab = this.$window.open(url, '_blank');
            documentTab.document.title = document.Title;

            try {
                const description = `Document ID: ${id}`;
                await this.TelemetryService.logTelemetry('View Building Document', description);
            } catch (error) {
                console.error(`Error while logging Telemetry for Building Document: ${description}`);
            }
            return;
        }

        const { Title, Level, TreeId, ParentId } = document;

        const tempBreadCrumbs = {
            Title,
            Level,
            TreeId,
            ParentId
        };

        this.buildingDocumentsBreadCrumbs.push(tempBreadCrumbs);
        for (let j = 0; j < this.buildingDocumentsFlatFile.length; j++) {
            const documentOriginal = this.buildingDocumentsFlatFile[j];
            if (documentOriginal.TreeId === document.TreeId) {
                this.buildingDocumentsFlatFile = documentOriginal.Children;
                break;
            }
        }

        return;
    }

    buildingDocumentsBreadCrumbClick(breadCrumb) {
        if (
            this.buildingDocumentsBreadCrumbs[this.buildingDocumentsBreadCrumbs.length - 1].TreeId == breadCrumb.TreeId
        ) {
            return;
        }

        const breadCrumbList = this.buildingDocumentsBreadCrumbs;
        breadCrumbList.shift();
        breadCrumbList.length = breadCrumb.Level;

        this.buildingDocumentsFlatFile = [];
        this.buildingDocumentsBreadCrumbs = [
            {
                Title: 'Home',
                Level: null,
                TreeId: null,
                ParentId: null
            }
        ];
        this.buildingDocumentsFlatFile = this.buildingDocuments;

        if (breadCrumb.Level !== null) {
            for (let i = 0; i < breadCrumbList.length; i++) {
                for (let j = 0; j < this.buildingDocumentsFlatFile.length; j++) {
                    const documentOrignal = this.buildingDocumentsFlatFile[j];
                    if (documentOrignal.TreeId === breadCrumbList[i].TreeId) {
                        this.buildingDocumentsFlatFile = documentOrignal.Children;
                        const tempInternalDocumentsBreadCrumbs = {
                            Title: documentOrignal.Title,
                            Level: documentOrignal.Level,
                            TreeId: documentOrignal.TreeId,
                            ParentId: documentOrignal.ParentId
                        };

                        this.buildingDocumentsBreadCrumbs.push(tempInternalDocumentsBreadCrumbs);
                        break;
                    }
                }
            }
        }
    }

    async _switchLoadingIndicator(flag) {
        return this.$timeout(() => {
            this.isBusy = flag;
        });
    }

    renderHtml(htmlString) { }
}
